import {ISegmentationTargetDTO, SegmentationTarget} from "@/modules/Segmentation/models/SegmentationTarget";
import {DateCustom} from "frontend-core";
import {SegmentRule} from "@/modules/Segmentation/models/SegmentRule";
import {AntiSegmentRule} from "@/modules/Segmentation/models/AntiSegmentRule";
import {Agent} from "@/models/Agent";

export class SegmentationImage extends SegmentationTarget {
    changeAgentId: string;
    prevImageId: string;
    createdAt: DateCustom;
    changeAgent: Agent | null;
    actions: SegmentationActions;
    description: Description;

    constructor(dto?: ISegmentationImageDto)
    constructor(
        segments?: SegmentRule[],
        antiSegments?: AntiSegmentRule[],
        id?: string,
        prevImageId?: string,
        agentId?: string,
        changeAgentId?: string,
        parentId?: string | null,
        createdAt?: DateCustom,
        actions?: SegmentationActions,
        description?: Description,
    )
    constructor(
        segmentsOrDTO: SegmentRule[] | ISegmentationImageDto = [],
        antiSegments: AntiSegmentRule[] = [],
        id: string = "",
        prevImageId: string = "",
        agentId: string = "",
        changeAgentId: string = "",
        parentId: string | null = null,
        createdAt: DateCustom = new DateCustom(),
        actions: SegmentationActions = {} as SegmentationActions,
        description: Description = {} as Description,
    ) {
        if (!Array.isArray(segmentsOrDTO)) {
            super(segmentsOrDTO);

            this.actions = segmentsOrDTO.actions;
            this.description = segmentsOrDTO.description;
            this.changeAgentId = segmentsOrDTO.changeAgent.id;
            this.prevImageId = segmentsOrDTO.prevImage;
            this.createdAt = new DateCustom(segmentsOrDTO.createdAt);
            this.changeAgent = new Agent(segmentsOrDTO.changeAgent.id, segmentsOrDTO.changeAgent.name);
        } else {
            // TODO: check if unused and remove during refactor
            super(segmentsOrDTO, antiSegments, id, agentId, parentId);

            this.changeAgentId = changeAgentId;
            this.prevImageId = prevImageId;
            this.createdAt = createdAt;
            this.changeAgent = null;
            this.actions = actions;
            this.description = description;
        }

    }
}

export type ISegmentationImageDto = ISegmentationTargetDTO & Readonly<{
    actions: SegmentationActions;
    description: Description;
    changeAgent: ISegmentationImageAgentDto;
    prevImage: string;
    createdAt: string;
}>;

export type ISegmentationImageAgentDto = Readonly<{
    id: string;
    name: string;
}>

export type SegmentationActions = {
    added: boolean,
    changed: boolean,
    deleted: boolean,
    off: boolean,
    on: boolean,
    [key: string]: boolean
}

export type Description = {
    [key: string]: { // added, changed, deleted, off, on
        title: string
    }[] 
}